import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { TcUploadFileService } from '../../services/tc-upload-file.service';

@Component({
  selector: 'tc-upload-file',
  templateUrl: './tc-upload-file.component.html',
  styleUrls: ['./tc-upload-file.component.scss'],
})
export class TcUploadFileComponent implements OnInit, OnDestroy {
  url = '';

  file: File;

  overlayVisible = false;
  progress = 0;
  uploadStatus: any;

  progressSubscription: Subscription;
  forkJoinProgressSubscription: Subscription;
  bodyProgressSubscription: Subscription;

  @ViewChild('fileInput', { static: false }) fileInput;

  constructor(public uploadService: TcUploadFileService) {}

  ngOnInit() {}

  uploadFile(url: string) {
    this.url = url;
    this.fileInput.nativeElement.value = '';
    this.fileInput.nativeElement.click();
  }

  onFileAdded() {
    this.overlayVisible = true;

    this.file = this.fileInput.nativeElement.files[0];

    this.uploadStatus = this.uploadService.upload(this.file, this.url);

    this.progressSubscription = this.uploadStatus.progress.subscribe((p) => {
      this.progress = p;
    });

    this.forkJoinProgressSubscription = forkJoin(
      this.uploadStatus.progress
    ).subscribe((end) => {
      this.overlayVisible = false;
    });

    this.bodyProgressSubscription = forkJoin(this.uploadStatus.body).subscribe(
      (body) => {
        if (body) {
          this.onFileUploaded(body[0]);
        }
        this.overlayVisible = false;
      }
    );
  }

  onFileUploaded(file: any) {}

  ngOnDestroy() {
    if (this.progressSubscription) {
      this.progressSubscription.unsubscribe();
    }

    if (this.forkJoinProgressSubscription) {
      this.forkJoinProgressSubscription.unsubscribe();
    }

    if (this.bodyProgressSubscription) {
      this.bodyProgressSubscription.unsubscribe();
    }
  }
}
